import { Injectable } from '@angular/core'

import { Observable } from 'rxjs/Observable'

import { LectureApiBase } from './lecture-api'
import { Video } from '../models'
import { PaginatedList } from '../libs/infinite-paginator'

@Injectable()
export class VideoApi {
  private apiPath = 'videos'

  constructor(
    private api: LectureApiBase,
  ) { }

  index(lectureId: number): PaginatedList<Video> {
    return this.api.listWithPaginate<Video>(Video, this.api.makeUrlWithParams(this.apiPath, { lectureId }))
  }

  get(id: number): Observable<Video> {
    return this.api.getWithObject(Video, `${this.apiPath}/${id}`)
  }

  update(id: number, params: any): Observable<Video> {
    return this.api.putWithObject<Video>(Video,`${this.apiPath}/${id}`, params)
  }

  create(lectureId: number, name: string, youtubeId: string): Observable<Video> {
    return this.api.postWithObject<Video>(Video, this.apiPath, { lectureId, name, youtubeId })
  }

  createNhkVideo(lectureId: number, name: string, dasId: string): Observable<Video> {
    return this.api.postWithObject<Video>(Video, this.apiPath, { lectureId, name, dasId })
  }
}



// WEBPACK FOOTER //
// ./src/apis/video.ts